<template>
  <NDropdown :trigger="['click']" placement="bottomRight">
    <span class="n-language-switcher grid grid-flow-col items-center gap-1 cursor-pointer auto-cols-max">
      <!--      <img :src="curLanguage.flag" width="30" />-->
      <span width="30">{{ curLanguage.label }}</span>
      <DownOutlined />
    </span>

    <template #overlay>
      <NMenu @click="onClick">
        <NMenuItem v-for="item in options" :key="item.value">
          <div class="grid grid-flow-col items-center gap-2 grid-cols-[1fr]">
            <!--            <img :src="item.flag" width="30" />-->
            {{ item.label }}
          </div>
        </NMenuItem>
      </NMenu>
    </template>
  </NDropdown>
</template>

<script setup>
import {useLanguage} from '@front/hooks';

const { options, curLanguage, changeLanguage } = useLanguage();

function onClick({ key }) {
  changeLanguage(key);
}
</script>

<script>
export default {
  name: 'NLanguageSwitcher',
};
</script>

<style scoped></style>
